import { assert, DoubleMap, KeyedSet } from '@deqo/foundation';
import { Interceptor } from './Interceptor';

export class InterceptorRegister {

    private store = new KeyedSet<Interceptor>(x => x.id);
    private cache = new DoubleMap<string, string, Interceptor[]>();

    public add(it: Interceptor) {
        assert(!this.store[it.id], `InterceptorRegister: ${it.id} already registered.`);
        this.store.add(it);
        this.cache.clear();
    }

    public remove(it: Interceptor) {
        this.store.remove(it);
        this.cache.clear();
    }

    public get(id: string) {
        return this.store.get(id);
    }

    public query(type: string, property: string) {
        return this.cache.get(type, property) ?? this.resolve(type, property);
    }

    private resolve(type: string, property: string) {
        const hits = this.store.filter(x => (x.type === type || x.type === '*') && x.property === property);
        this.cache.set(type, property, hits);
        return hits;
    }
}
